const Glide = require("@glidejs/glide/dist/glide.esm").default;

class AddChannelSlider {
  private root: HTMLElement | null = null;
  private glide: Glide | null = null;
  private slides: HTMLElement[] = [];

  constructor() {
    this.root = document.querySelector(".add-channel__slider.glide");
    this.slides = Array.from(this.root?.querySelectorAll(".glide__slide") || []);
    if (!this.root) return;
    this.init();
  }

  onMount() {
    this.slides = Array.from(this.root?.querySelectorAll(".glide__slide") || []);
  }

  private init() {
    if (!this.root) return;
    const options: Partial<Glide.Options> = {
      type: "carousel",
      startAt: 0,
      perView: 1,
      gap: 0,
      hoverpause: true,
      autoplay: 5000,
      animationDuration: 500,
      animationTimingFunc: "ease-in-out",
      // make types happy by narrowing optional fields to valid shapes
      focusAt: 0,
      direction: "ltr",
      breakpoints: {},
      classes: {
        swipeable: "glide--swipeable",
        dragging: "glide--dragging",
        direction: { ltr: "glide--ltr", rtl: "glide--rtl" },
        type: { slider: "glide--slider", carousel: "glide--carousel" },
        slide: { clone: "glide__slide--clone", active: "glide__slide--active" },
        arrow: { disabled: "glide__arrow--disabled" },
        nav: { active: "glide__bullet--active" },
      },
    };

    this.glide = new Glide(this.root, options);
    if(this.slides.length <= 0) return;
    if (this.glide) {
      this.glide.on("mount.before",()=>{
        this.onMount();
      });
      this.glide.mount();
    }

    const controls = document.querySelector('.add-channel__slider-controls');
    if (!controls) return;
    controls.addEventListener('wheel', (e: Event) => {
      e.preventDefault(); // Prevent page scrolling
      
      const wheelEvent = e as WheelEvent;
      if (wheelEvent.deltaY > 0) {
        // Scrolling down, go to next slide
        this.glide?.go('>');
      } else {
        // Scrolling up, go to previous slide
        this.glide?.go('<');
      }
    });
  }
}

export default function addChannelSlider() {
  return new AddChannelSlider();
}